export default __webpack_public_path__ + "static/banner-media-release-shopping-a9ef3218ee763f6ed68ceb55e3d0a2b1.jpg";